import { Component, OnInit, ViewChild,VERSION, ElementRef, Input, AfterViewInit, ViewEncapsulation, Optional, Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import {SignaturePad} from 'angular2-signaturepad/signature-pad';
import {  Observable, Subject } from 'rxjs/Rx';
import { switchMap, takeUntil, pairwise, startWith, map } from 'rxjs/operators';
import { ToastUiImageEditorComponent } from 'ngx-tui-image-editor';
import { ImageTemplateComponent } from './image-template/image-template.component';
import { SaveTemplateModel, TemplateModel } from './Models/GetImageTemplateMaste.model';
import { imageworkupService } from './Services/Imageworkup.services';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { FormControl } from '@angular/forms';
import { EMRService } from '../EMR.service';
import { DatePipe } from '@angular/common';
import { IpdWorkupModel } from './Models/IpdImageworkup.model';
@Component({
  selector: 'app-Image_workup',
  templateUrl: './Image_workup.component.html',
  styleUrls: ['./Image_workup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class Image_workupComponent implements AfterViewInit {
  destroyimageworkup$: Subject<boolean> = new Subject<boolean>();
   options = {
    usageStatistics: false,
  };
  name = 'BGI Test' + VERSION.major;
  public getTemplateArray:TemplateModel[]=[];
  public savetemplateobj:TemplateModel={};
  editImage:any;
  @ViewChild(ToastUiImageEditorComponent,{static: false })
  public editorComponent: ToastUiImageEditorComponent;
  @ViewChild('canvas', {static: false}) public canvas: ElementRef;

  @Input() public width = 400;
  @Input() public height = 400;
  private imageedit =  "assets/img/pro1.jpg";
  private imageeditlefteye =  "assets/img/pro1.jpg";
  private cx: CanvasRenderingContext2D;
  image = new Image();
  private templatelength:number;
  private value = 50;
  private backToField:boolean = true;
  private searchtemplate:any;
  worktype:string='';
 private newvalaue:number;
  private doctorid:number;
  private visitid:number;
  private TfolderName:any;
  private showspinner:any;
  private subSpecialityCtrl: FormControl;
  private subSpecialityOptions: Observable<any[]>;
  private subsepceialdata:any=[];
  private visitcomparedate:any;
  private visitcomparedate1:any;
  private defaultcompareimage:any='';
  private defaultcompareimageleft:any='';
  private teplatedetail:TemplateModel={};
  private workupvisitcomparedate:any;
  private allresultcaption:string=''
  private leftvisitid:number;
  private rigthvisitid:number;
  private defimage: any;
  private processbarwidth : any=0;
  constructor(private datePipe:DatePipe,private emrservice :EMRService,private dialog: MatDialog,private dialogRef: MatDialogRef<Image_workupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,private imageworkService:imageworkupService,
  private dashboardService:DashboardService,private authService:AuthService,private opdvisitService: OpdVisitService,) {
    dialogRef.disableClose = true;
    this.editImage ='../../../assets/img/no-image.jpg';
    
  }
  ngOnInit(){
    this.subsepceialdata=[];
    this.teplatedetail={};
      this.allresultcaption='All Results';
      this.ipdimageobjData.pK_TranId=0;
      this.ipdimageobjData.imageDescriptionOD=null;
      this.ipdimageobjData.imageDescriptionOS=null;
   
    this.templatelength =3;
    this.doctorid =this.data.Doctorid;
    this.visitid =this.data.visitid;
    this.leftvisitid =this.data.visitid;
    this.rigthvisitid =this.data.visitid;
    this.documentURL();
   // this.folderName =this.data.folderName;
    this.TfolderName='IMAGETEMPLATE';
    this.showspinner =false;
    this.getSpecilityData(0);
    this.subSpecialityCOntrol();

    this.itemsPerSlide = this.mobileDevice() ? 2 : 1;
    this.allresultcaption='';
    console.log(this.opdvisitService.mainUrl);
  }
  ngOnDestroy() {
    this.destroyimageworkup$.next(true);
    this.destroyimageworkup$.unsubscribe();
    this.rigthvisitid=null;
    this.leftvisitid=null;
    this.visitid=null;
    this.doctorid=null;
    this.templatelength=null;
    this.showspinner=null;
    this.ipdimageobjData=null; 
    this.subsepceialdata=null; 
    this.teplatedetail=null; 
    this.allresultcaption=null; 
    this.workupvisitcomparedate=null; 
    this.TfolderName=null; 
    this.worktype=null; 
    
  }
  showImage(img:any){
   this.defaultcompareimage=img;
  }
  showImageleft(img:any){
    this.defaultcompareimageleft=img;
  }
  getSpecilityData(id){
    this.subsepceialdata =[];
    this.emrservice.getSpeciltiyData(id).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
      this.subsepceialdata =x;
      this.subSpecialityCOntrol();
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
   }
  // sup sepeciality auto
  subSpecialityCOntrol(){
    this.subSpecialityCtrl = new FormControl();
    this.subSpecialityOptions = this.subSpecialityCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.subfilterfunction(cat) : this.subsepceialdata.slice())
      );
  }
  subfilterfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.subsepceialdata.filter(country =>
      country.subSpecialityName?.toLowerCase().indexOf(filterValue) === 0);

  }
  getSubspecialbj(e: any) {
    var val = e.option.value;
    this.savetemplateobj.subSpeciality=val.subSpecialityName;
    this.savetemplateobj.fk_SubSpecialityId=val.pK_SubSpecialityId;
  }
  Checkinputsub(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.subSpecialityCOntrol();
      this.savetemplateobj.subSpeciality = null;
    }else{
      this.savetemplateobj.subSpeciality = null; 
    }
  }
 Cleartemplatedata(){
  this.savetemplateobj={};
  this.imageTemplateArray=[];
  this.imageTemplateArray.push('../../../assets/img/noimage.png');
 }
 importFile(event) {
  this.runProgressBar();
  if(this.savetemplateobj.pK_TranId >0){
  
  if(this.savetemplateobj.templateName !=null && this.savetemplateobj.templateName !=undefined && this.savetemplateobj.templateName !=""){
    if (event.target.files.length == 0) {
      console.log("No file selected!");
      return
   }
  
  // this.showspinner =true;
     let file: File = event.target.files[0];
     if (this.authService.webstorageConfigobj.imageFileSize != null && this.authService.webstorageConfigobj.imageFileSize != undefined && Number(this.authService.webstorageConfigobj.imageFileSize) > 0) {
      if (Number(this.authService.webstorageConfigobj.imageFileSize) * 1024 >= file.size) {
      let fileToUpload = file;
      let fnsplit = file.name.split(".",2);
      let actualdocumentname = this.savetemplateobj.templateName + "." + fnsplit[1];
      console.log("image name" + actualdocumentname)
      const formData = new FormData(); 
      formData.append('file', fileToUpload,  this.savetemplateobj.pK_TranId + '_' + this.savetemplateobj.templateName +'_'+this.savetemplateobj.subSpeciality+ "." + fnsplit[1]);
      formData.append('documentname', this.savetemplateobj.pK_TranId + '_' + this.savetemplateobj.templateName +'_'+this.savetemplateobj.subSpeciality);
      formData.append('patientid', this.savetemplateobj.pK_TranId.toString());
      formData.append('branchId',this.authService.Loggeduser.branchid.toString());
      formData.append('FolderNameMain','IMAGETEMPLATE');
     this.imageworkService.uploadDoc(formData).pipe(takeUntil(this.destroyimageworkup$)).subscribe(
      data=> this.successfileupload(data), err=> this.failedfileupload(err))  
    } else {
      this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authService.webstorageConfigobj.documentFileSize + ' Kb', "OK");
    }
  } else {
    this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
  }
     }
     else{
       this.dashboardService.openSnackBar("Template Name is required", "OK");
      }
  }else{
    this.dashboardService.openSnackBar("First Save template or Search the template then upload Image", "OK");
  }
}
  url:any;
  successfileupload(data){   
    this.showspinner =false;
  // this.getTemplateImagedata();
  this.getTemplatedataid(this.savetemplateobj.pK_TranId);
  this.dashboardService.openSnackBar( " Uploaded Successfully", "OK");
 
  }
  runProgressBar(){
    Observable.timer(0,20)
    .takeWhile(()=>
       this.isWidthWithinLimit()
       )
    .subscribe(()=>{
      this.processbarwidth=this.processbarwidth+1;
      
    })
    
  }

  isWidthWithinLimit(){
    if(this.processbarwidth===100){
      return false;
    }else{
      return true;
    }
  }
  failedfileupload(err){
    this.showspinner =false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
 
  }
 showalldata(){
  this.templatelength= this.getTemplateArray.length;
 }
 imageAll(){
  this.allresultcaption='All Results';
  this.getTemplatedata(0);
 }
 allimageArray:any=[];
 getTemplatedata(id){
  this.getTemplateArray =[];
  this.allimageArray=[];
  this.imageworkService.getTempaltedata(id).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
    this.getTemplateArray =x;
    if( this.getTemplateArray.length >0){
      this.getTemplateArray.forEach(item=>{
        this.allimageArray.push({pK_TranId: item.pK_TranId,
          templateName: item.templateName,
          eye: item.eye,
          templateDescription: item.templateDescription,
          folderName: item.folderName,
          fK_CreatedById: item.fK_CreatedById,
          createDateTime: item.createDateTime,
          isActive: item.isActive,
          isEdit: item.isEdit,
          isDelete: item.isDelete,
          imageName:item.fbLong,
          fk_SubSpecialityId: item.fk_SubSpecialityId,
          subSpeciality: item.subSpeciality});
      });
    }
  },err=>{
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  });
 }
 imageFilter(subid,subname){
 
  this.allresultcaption=subname;
   let filterimage =this.getTemplateArray.filter(item=>item.fk_SubSpecialityId ==subid);
   this.allimageArray=[];
   if(filterimage.length >0){
  filterimage.forEach(item=>{
      this.allimageArray.push({pK_TranId: item.pK_TranId,
        templateName: item.templateName,
        eye: item.eye,
        templateDescription: item.templateDescription,
        folderName: item.folderName,
        fK_CreatedById: item.fK_CreatedById,
        createDateTime: this.datePipe.transform(item.createDateTime, "yyyy-MM-dd"),
        isActive: item.isActive,
        isEdit: item.isEdit,
        isDelete: item.isDelete,
        imageName:item.fbLong,
        fk_SubSpecialityId: item.fk_SubSpecialityId,
        subSpeciality: item.subSpeciality});
    });
  }else{
    this.allimageArray=[];
  }
 
 }
 getImage(templatedata:any){
  this.showspinner =true;
  this.teplatedetail =templatedata;
  this.backToField = !this.backToField;
    this.editorComponent.editorInstance
    .loadImageFromURL(templatedata.imageName
     ,
      'imageName'
    )
    .then((result) => {
    //  document.getElementById('drawer').style.display = "none";
      this.showspinner =false;
      this.editorComponent.editorInstance.ui.activeMenuEvent();
    });
 }
 filterbydateworkup(selecteddate: string){
  this.workupvisitcomparedate='';
  let container = selecteddate.split("/", 3);

  let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];

  this.workupvisitcomparedate = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");
 
 }
 filterbydate(selecteddate: string) {
 this.defaultcompareimage='';
  let container = selecteddate.split("/", 3);

  let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];

  this.visitcomparedate1 = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");
  this.filterworkdata(this.visitcomparedate,2);
 }
 filterbydateleft(selecteddate: string){
  this.defaultcompareimageleft='';
  let container = selecteddate.split("/", 3);

  let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];

  this.visitcomparedate = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");
  this.filterworkdata(this.visitcomparedate,1);
 }

 filterworkdata(nedate:any ,type:number){
     if(type==1){
      let checkvalu =this.saveimageArray.filter(item=>item.visitDate ==nedate);
      this.leftvisitid =checkvalu[0]?.fK_VisitId?checkvalu[0]?.fK_VisitId:null;
     }else if(type==2){
      let rcheckvalu =this.saveimageArray.filter(item=>item.visitDate ==nedate);
      this.rigthvisitid =rcheckvalu[0]?.fK_VisitId?rcheckvalu[0]?.fK_VisitId:null;
     }
   
 }
 getTemplatedataid(id){
  this.savetemplateobj ={};
  this.imageTemplateArray=[];
   this.imageworkService.getTempaltedata(id).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
   
    this.savetemplateobj =x[0];
    if(this.savetemplateobj.fbLong !=null){
      this.imageTemplateArray.push(this.savetemplateobj.fbLong);
    }else{
      this.imageTemplateArray.push('../../../assets/img/noimage.png'); 
    }
  },err=>{
    
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  });
 }
 getRowdata(rowdata){
  this.imageTemplateArray=[];
  this.savetemplateobj ={};
  this.savetemplateobj =rowdata;
  if(rowdata.fbLong !=null){
    this.imageTemplateArray.push(rowdata.fbLong );
  }else{
    this.imageTemplateArray.push('../../../assets/img/noimage.png'); 
  }
 
  //this.getTemplateImagedata();
  document.getElementById("templateSearchRecordModal").style.display = "none";
 }
 Savetemplatedata(){
 if(this.savetemplateobj.templateName !=null && this.savetemplateobj.subSpeciality && this.savetemplateobj.eye){
  
  let newobj={
    ImageTemplateMaster:{
      "isEdit": this.savetemplateobj.pK_TranId >0 ? 1 :0,
      "isDelete": 0,
      "pK_TranId": this.savetemplateobj.pK_TranId >0 ? this.savetemplateobj.pK_TranId :0,
     "templateName": this.savetemplateobj.templateName,
     "speciality":  this.savetemplateobj.subSpeciality,
     "Fk_SubSpecialityId":this.savetemplateobj.fk_SubSpecialityId,
     "eye": this.savetemplateobj.eye,
     "templateDescription": this.savetemplateobj.templateDescription?this.savetemplateobj.templateDescription:null,
    "folderName": this.savetemplateobj.templateName,
    "fK_CreatedById": this.authService.Loggeduser.userid,
    "createDateTime": this.authService.localDate,
    "isActive": true
    }
   }
    this.imageworkService.insertTemplatedata(newobj).pipe(takeUntil(this.destroyimageworkup$)).subscribe(x=>{
    this.savetemplateobj ={};
    this.getTemplatedataid(x['id']);
    this.getTemplatedata(0);
    this.dashboardService.openSnackBar("Record saved successfully", "OK");
   },(err:any)=>{

    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   });
 
 }else{
  this.dashboardService.openSnackBar("Mandatory field are required", "OK");
 }

 }
 imageTemplateArray:any=[];
//  getTemplateImagedata(){
//   this.imageTemplateArray=[];
// this.imageworkService.getImagedata(this.savetemplateobj.pK_TranId,this.authService.Loggeduser.branchid,'IMAGETEMPLATE').subscribe((x:any)=>{
//    if(x.length >1){ 
//     console.log(x.length);
//     x.forEach(item=>{
//       var newitem= this.mainUrl+this.TfolderName+'/'+ this.savetemplateobj.pK_TranId +'/'+ item + "?" + Math.floor(Math.random() * 100) + 1;
//       this.imageTemplateArray.push(newitem)
//     })
//    }else{
//     this.imageTemplateArray.push('../../../assets/img/noimage.png');
//    }
// });
// }

  public ngAfterViewInit() {
    
  this.editorComponent.editorInstance.ui.useDefaultUI = false;
  // this.editorComponent.editorInstance.ui.options.menu = [
  //   'crop',
  //   'flip',
  //   'rotate',
  //   'draw',
  //   'shape',
  //   'icon',
  //   'text',
  //   'filter',
  // ]; 
  this.editorComponent.editorInstance.ui.options.menuBarPosition = 'bottom';
  this.editorComponent.editorInstance.ui.options.initMenu = '';
  // (this.editorComponent.editorInstance.ui.options.uiSize = {
  //   width: '1000px',
  //   height: '700px',
  // }),
 
    this.editorComponent.editorInstance.ui.options.usageStatistics=false,
   
    this.editorComponent.editorInstance
      .loadImageFromURL(
        this.editImage,
        'image'
      )
      .then((result) => {
        this.editorComponent.editorInstance.ui.activeMenuEvent();
      });
  console.log(this.editorComponent.editorInstance);
 // console.log(this.editorComponent.editorInstance.ui);
//  $('.tui-image-editor-header-buttons .tui-image-editor-download-btn').
// replaceWith('<button class="tui-image-editor-save-btn btn  btn-primary btn-sm" >Save</button>')
 
  
//   document.querySelector('.tui-image-editor-header-buttons .tui-image-editor-save-btn').
//   addEventListener('click', this.prcoessSaveImage);
  // let dataurl =this.editorComponent.editorInstance._graphics.getCanvas();
  // let reladata= dataurl.toDataURL();

//   setTimeout(()=>{   
//   let newurl =this.editorComponent.editorInstance.toDataURL();
//   console.log(newurl);
 
// }, 6000)
 

  }
  
  documentrul:any=[];
 // mainUrl:any;
  documentURL(){
    // this.documentrul =[];
    // this.dashboardService.getdocument_url().subscribe(data=>this.success_docurl(data),err=>this.failed_docurl(err));
     this.getimagedata();
     this.getTemplatedata(0);
     this.recentuserimges(4);
   
    
  }
  ipdimagearrayData:IpdWorkupModel[]=[];
  ipdimageobjData:IpdWorkupModel={};
  getIPDWorkUpsavedata(regid,ipdid,transid){
     this.imageworkService.getIPDImageworkup(regid,ipdid,transid).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
       this.ipdimagearrayData =[];
       this.ipdimagearrayData =x;
       console.log(this.ipdimagearrayData);
       if(this.ipdimagearrayData.length >0){
        for(var i=0;i< this.ipdimagearrayData.length; i++){ 
          this.ipdimagearrayData[i].imageName = this.returnbase64( this.ipdimagearrayData[i].imageName);
         }
       }
     },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
     })
  }


  // success_docurl(data){
   
    
  // this.documentrul=data;
  // var urldoc=this.documentrul.filter(item => item.propertyName =="MainImagePathWebNetram")
  //   this.mainUrl=urldoc[0]?.propertyValue;
  //    this.getimagedata();
  //    this.getTemplatedata(0);
  //    this.recentuserimges(4);
  //    this.getIMagesavedata(this.opdvisitService.patientdetails.pkRegId);
  // }
  // failed_docurl(err){

  // }

  imageUndo(){
    this.editorComponent.editorInstance.undo();
  }

  imageredo(){
    this.editorComponent.editorInstance.redo();
  }


  saveimage(){
    
    let newurl =this.editorComponent.editorInstance.toDataURL();
    let blob = this.base64toBlob(newurl);
    const formData = new FormData(); 
    formData.append('file', blob);
    formData.append('documentname', blob.name);
    formData.append('patientid', this.opdvisitService.patientdetails.pkRegId.toString());
    formData.append('branchId',this.authService.Loggeduser.branchid.toString());
    formData.append('VisitId',this.visitid.toString());
    formData.append('DoctorId',this.doctorid.toString());
    formData.append('ImageTemplateId',(this.teplatedetail.pK_TranId?this.teplatedetail.pK_TranId:0).toString());
    formData.append('FolderNameMain',this.data.folderName);
    formData.append('PkTranId', this.opdvisitService.dataSource.length > 0 ? this.opdvisitService.dataSource[0].pk_TranId.toString() : '0');
    formData.append('ActionType', "UPLOAD");
   this.imageworkService.uploadDoc(formData).pipe(takeUntil(this.destroyimageworkup$)).subscribe(
    data=> this.successworkuupupload(data), err=> this.failedfileupload(err))  
  }
  successworkuupupload(data){   
   
  this.dashboardService.openSnackBar( " Uploaded Successfully", "OK");
   
   if(this.data.folderName=='OTImages'){
    this.saveIPDworkupImage()
   }else{
    this.getimagedata();
   }
   this.recentuserimges(4);
  }
  saveIPDworkupImage(){
    let payload={
      "OtImageDetail":{
        "pK_TranId": this.ipdimageobjData.pK_TranId?this.ipdimageobjData.pK_TranId:0,
        "fK_RegId": this.opdvisitService.patientdetails.pkRegId,
        "opdDate":this.authService.localDate,
        "imageName": this.visitid+'_'+this.doctorid+'.jpg',
        "imageDescriptionOD": this.ipdimageobjData.imageDescriptionOD,
        "imageDescriptionOS": this.ipdimageobjData.imageDescriptionOS,
        "fK_CreatedById": this.authService.Loggeduser.userid,
        "isActive": true,
        "imageFrom": "WebNetram",
        "fk_IPDId": this.data.visitid,
        "isEdit": this.ipdimageobjData.pK_TranId>0?true: false,
        "isDeleted": false
    }
    }
    this.imageworkService.insertIPDImageWorkup(payload).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
      this.getimagedata();
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  base64toBlob(base64, filename =this.visitid+'_'+this.doctorid+'.jpg', format = 'jpg') {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
   return  new File([u8arr], filename, {type: format});
  }
  imageArray:any=[];
  getimagedata(){
      this.imageArray=[]; 
      this.opdvisitService.dataSource=[]; 
    this.imageworkService.getAzureImagedata(this.opdvisitService.patientdetails.pkRegId,this.authService.Loggeduser.branchid,this.data.folderName).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
       if(x.length >0){ 
        this.opdvisitService.dataSource=x;
        x.forEach(item=>{
          let payload={
            "doucmentName":item.documentName,
            "imageName": item.fbLong
          }
          this.imageArray.push(payload);
        });
        if(this.data.folderName=='OPDWorkup'){
          this.visitcomparedate= this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd");
          this.visitcomparedate1=this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd");
          this.workupvisitcomparedate=this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd");
          this.getIMagesavedata(this.opdvisitService.patientdetails.pkRegId);
         }
         if(this.data.folderName=='OTImages'){
          this.visitcomparedate= this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
          this.visitcomparedate1=this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
          this.workupvisitcomparedate=this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
          this.getIPDWorkUpsavedata(this.opdvisitService.patientdetails.pkRegId,this.data.visitid,0);
         }
       }
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
   }
   returnbase64(data:any){
   if(this.imageArray.length >0){
     return this.imageArray.filter(item=>item.doucmentName==data)[0]?.imageName ?this.imageArray.filter(item=>item.doucmentName==data)[0]?.imageName :'../../../assets/img/noimage.png';
   }else{
   return '../../../assets/img/noimage.png';
   }
   }
   retuntooltip(visitdr,visitSubSpeciality){
    if(visitdr !=undefined && visitSubSpeciality !=undefined){
      return visitdr+'_'+visitSubSpeciality;
    }else if(visitdr !=undefined){
      return visitdr;
    }else if(visitSubSpeciality !=undefined){
      return visitSubSpeciality;
    }
   }
  dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
}
  // new
  save(ev) {
    console.log(ev);
  }
  saveleft(ev){
    console.log(ev);
  }
  drawimage(){
      this.image.onload = ()=> {
          this.cx.drawImage(this.image, 0, 0, this.width, this.height);
       }
       this.image.src = "assets/img/pro1.jpg";
  }
 
  savecanvas(event:any){
 
   let image = this.canvas.nativeElement.toDataURL("image/png").replace("image/png", "image/octet-stream");
    var link = document.createElement('a');
    link.download = "my-image.png";
    link.href = image;
    link.click();
  }
 

 

  cleardrawings(){
    this.cx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
    this.drawimage();
  }

  closedialog(){
   
    this.dialog.closeAll();
  }

  openImageTemplate() {
    const dialogRef = this.dialog.open(ImageTemplateComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '75vw',
      disableClose: true,
      width: '75%',
      height:'75%',
      data :{
       imagetemplateArray:this.allimageArray
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyimageworkup$)).subscribe(result => {
      console.log( result);
      if(result !=0){
        this.teplatedetail =result.arrayobj;
        this.backToField = !this.backToField;
        this.editorComponent.editorInstance
        .loadImageFromURL( result.blob64,
          'imageName'
        )
        .then((result) => {
          this.editorComponent.editorInstance.ui.activeMenuEvent();
        });
        // this.editorComponent.editorInstance
        // .loadImageFromURL( `https://cors-fix.web.app/v1?url=${result.imageName}`,
        //   'imageName'
        // )
        // .then((result) => {
        //   this.editorComponent.editorInstance.ui.activeMenuEvent();
        // });
        
      }
    });
  }
 
  
  showImageworkup(imageurl:any){
   // this.teplatedetail.templateName =imageurl.templateName;
  //  this.teplatedetail.pK_TranId=imageurl.fK_ImageTemplateId;
    this.backToField = !this.backToField;
    this.defimage = imageurl;
    this.showspinner =true;
    this.editorComponent.editorInstance
    .loadImageFromURL(imageurl, 'imageName')
    .then((result) => {
      this.showspinner =false;
      this.editorComponent.editorInstance.ui.activeMenuEvent();
    });

  }
  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}
  comparePatientImages() {
    document.getElementById("comparePatientImagesModal").style.display = "block";
    if(this.defimage != null){
      this.showImageleft(this.defimage)
      this.showImage(this.defimage)
    }else{
      this.showImageleft(this.saveimageArray[0]?.imageName);
      this.showImage(this.saveimageArray[0]?.imageName);
    }
  }
  cancelComparePatientImages() {
    document.getElementById("comparePatientImagesModal").style.display = "none";
  }


  createTemplate() {
    this.imageTemplateArray=[];
    this.imageTemplateArray.push('../../../assets/img/noimage.png');
    document.getElementById("createTemplateModal").style.display = "block";
  }
  cancelCreateTemplate() {
    this.getTemplatedata(0);
    document.getElementById("createTemplateModal").style.display = "none";
  }
   recentuserImage:any=[];
  recentuserimges(norecent){
    this.recentuserImage =[];
   this.imageworkService.getRecentTempaltedata(norecent).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
     if(x.length >0){
      x.forEach(item=>{
        this.recentuserImage.push({pK_TranId: item.pK_TranId,
          templateName: item.templateName,
          eye: item.eye,
          templateDescription: item.templateDescription,
          folderName: item.folderName,
          fK_CreatedById: item.fK_CreatedById,
          createDateTime: item.createDateTime,
          isActive: item.isActive,
          isEdit: item.isEdit,
          isDelete: item.isDelete,
          imageName:item.fbLong,
          fk_SubSpecialityId: item.fk_SubSpecialityId,
          subSpeciality: item.subSpeciality});
      });
      console.log( this.recentuserImage);
     }else{
      this.recentuserImage=[];
     }
   }, err => {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   });
  }
  saveimageArray:SaveTemplateModel[]=[];
  getIMagesavedata(pateintid){
    this.saveimageArray=[];
    this.imageworkService.getsaveTemplate(pateintid).pipe(takeUntil(this.destroyimageworkup$)).subscribe((x:any)=>{
   
       if(x.length >0){
        x.forEach(item=>{
          this.saveimageArray.push({fK_RegId: item.fK_RegId,
            fK_VisitId: item.fK_VisitId,
            pK_ExamId: item.pK_ExamId,
            fK_BranchId: item.fK_BranchId,
            branchName: item.branchName,
            visitDate: this.datePipe.transform(item.visitDate, "yyyy-MM-dd"),
            doctorId: item.doctorId,
            opId: item.opId,
            drName: item.drName,
            opName: item.opName,
            imageName:this.returnbase64(item.imageName),
            subSpecialityName: item.subSpecialityName,
            visitDoctorId:item.visitDoctorId,
            visitDrName:item.visitDrName,
            visitSubSpecialityName:item.visitSubSpecialityName,
            });
        });
       }else{
        this.saveimageArray.push({fK_RegId: 0,
          fK_VisitId: null,
          pK_ExamId: null,
          fK_BranchId: null,
          branchName: null,
          visitDate: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
          doctorId: null,
          opId: null,
          drName: null,
          opName: null,
          imageName:'../../../assets/img/noimage.png',
          subSpecialityName: null,
          visitDoctorId:null,
          visitDrName:null,
          visitSubSpecialityName:null,
          });
       }
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  
   
  templateName(){
    this.backToField = !this.backToField;
  }
  
  editField(){
    this.backToField = !this.backToField;
  }
 
  openSearchtemplate() {
    document.getElementById("templateSearchRecordModal").style.display = "block";
  }
  canceltemplateSearchRecord() {
    document.getElementById("templateSearchRecordModal").style.display = "none";
  }





  private itemsPerSlide: number;
  slides = [
   {image: 'https://valor-software.com/ngx-bootstrap/assets/images/nature/1.jpg'},
   {image: 'https://valor-software.com/ngx-bootstrap/assets/images/nature/2.jpg'},
   {image: 'https://valor-software.com/ngx-bootstrap/assets/images/nature/3.jpg'}
 ];
 private mobileDevice(): boolean {
  return navigator.userAgent.match(/Android/i)
    ||  navigator.userAgent.match(/webOS/i)
    ||  navigator.userAgent.match(/iPhone/i)
    ||  navigator.userAgent.match(/iPad/i)
    ||  navigator.userAgent.match(/iPod/i)
    ||  navigator.userAgent.match(/BlackBerry/i)
    ||  navigator.userAgent.match(/Windows Phone/i)
    ? true : false;
}

};

 // constructor(public dialog: MatDialog) {

  //   let canvasEl = document.getElementById('canvas') as
  //   HTMLCanvasElement;

  //   // const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
  //   this.ctx = canvasEl.getContext("2d")!;
  //   let image = new Image();


  //   // canvasEl.width = this.width;
  //   // canvasEl.height = this.height;

  //   canvasEl.width = 350;
  //   canvasEl.height = 150;

  
  //   image.onload = ()=> {
  //       this.ctx.drawImage(image, 0, 0, this.width, this.height);
  //    }
  //   image.src = "assets/img/pro1.jpg";

  //  canvasEl.addEventListener("mousedown",startPosition);
  //  canvasEl.addEventListener("mouseup",finishedPosition);
  //  canvasEl.addEventListener("mousemove",draw);
  // }

 



 

